import PropTypes from "prop-types";
// @mui
import {
  Box,
  Card,
  Typography,
  Stack,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import ModalDialog from "src/components/Global/ModalDialog";

// ----------------------------------------------------------------------

const StyledResourceImg = styled("img")({
  top: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  position: "absolute",
});

// ----------------------------------------------------------------------

ResourceCard.propTypes = {
  resource: PropTypes.object,
};

export default function ResourceCard({ resource, isDeleting, onDelete, onEdit }) {
  const { title, image } = resource;

  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Card sx={{ opacity: isDeleting ? 0.3 : 1 }}>
      <Box sx={{ pt: "100%", position: "relative" }}>
        <StyledResourceImg alt={title} src={image} />
      </Box>

      <Stack spacing={1} sx={{ p: 2 }}>
        <Typography variant="subtitle">{title}</Typography>
      </Stack>
      <Box sx={{ pl: 2, mb: 3 }}>
        <Stack direction="row">
          <Button
            size="small"
            color="secondary"
            variant="outlined"
            onClick={isDeleting ? null : onEdit}
          >
            Edit
          </Button>
          <Button
            size="small"
            color="error"
            variant="outlined"
            sx={{ ml: 2 }}
            onClick={isDeleting ? null : handleOpenModal}
          >
            Delete
          </Button>
        </Stack>
      </Box>
      <ModalDialog
        title="Delete Resource?"
        subTitle={`Are you sure do you want to delete this resource?`}
        item={title}
        open={openModal}
        handleClose={handleCloseModal}
        handleClickOk={() => {
          handleCloseModal();
          onDelete();
        }}
      />
    </Card>
  );
}
